import { render, staticRenderFns } from "./ForeignSettings.vue?vue&type=template&id=78aee7d6&scoped=true"
import script from "./ForeignSettings.vue?vue&type=script&lang=js"
export * from "./ForeignSettings.vue?vue&type=script&lang=js"
import style0 from "./ForeignSettings.vue?vue&type=style&index=0&id=78aee7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aee7d6",
  null
  
)

export default component.exports